export default "__VITE_ASSET__CPwFJzBo__"